import Children from '../../../layouts/Children';

const routes = [
  {
    path: 'plannings',
    component: Children,

    children: [
      {
        path: '',
        name: 'plannings',
        component: () => import('../pages/PlanningPage')
      }
    ]
  }
];

export default routes;
